'use client'

import Modal from '@/components/Modal/Modal'
import { HelpTutorial, getYoutubeEmbedUrl } from './tutorials'

type TutorialPlayerModalProps = {
  tutorial: HelpTutorial | null
  onClose: () => void
}

const TutorialPlayerModal = ({ tutorial, onClose }: TutorialPlayerModalProps) => (
  <Modal
    isOpen={tutorial !== null}
    onClose={onClose}
    title={tutorial?.title}
    className="!p-0 w-[min(1100px,calc(100vw-96px))]"
    containerClassName="!py-[48px]"
    windowClassName="!min-h-[calc(100vh-96px)]"
  >
    {tutorial && (
      <div className="flex flex-col bg-white">
        <iframe
          key={tutorial.youtubeId}
          src={getYoutubeEmbedUrl(tutorial.youtubeId)}
          title={`${tutorial.title} tutorial`}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="aspect-video w-full border-0 bg-gray-900"
        />
        <p className="border-t border-gray-200 p-md text-text-md text-gray-500">{tutorial.description}</p>
      </div>
    )}
  </Modal>
)

export default TutorialPlayerModal
